import { internal, FormElementMixin, DelegateFocusMixin, FocusVisibleMixin, KeyboardMixin } from '../../vendor/elix.js';
import CheckableStylesMixin from './checkable-styles.js';
import EmptyReactiveElement from '../empty-reactive-element.js';
import ErrorMixin from '../mixins/error-mixin.js';


const spacebarWasPressed = (event) => event.code === 'Space' || event.keyCode === 32;

const baseClasses =
  CheckableStylesMixin(
  ErrorMixin(
  DelegateFocusMixin(
  FocusVisibleMixin(
  KeyboardMixin(
  FormElementMixin(
    EmptyReactiveElement
))))));

class CheckableInputBase extends baseClasses {
  get checked() {
    return this[internal.state].checked;
  }
  set checked(arg) {
    this[internal.setState]({ checked: arg });
    if (this.checked && this.inputChecked) {
      this.inputChecked();
    }
  }

  get name() {
    return this[internal.state].name;
  }
  set name(arg) {
    this[internal.setState]({ name: arg });
  }

  get value() {
    return this[internal.state].value;
  }
  set value(arg) {
    this[internal.setState]({ value: arg });
  }

  [internal.componentDidMount]() {
    super[internal.componentDidMount]();
    this.setupListeners();
  }

  setupListeners() {
    this.listenerCleanup = [];
    const setupKeyUpAnimationListenerForElement = (el) => {
      el.addEventListener('keyup', (e) => {
        if (spacebarWasPressed(e)) { this.removeAnimationArtifact(); }
      });
    };
    const setupMouseDownAnimationListenerForElement = (el) => {
      el.addEventListener('mousedown', this.enableAnimation.bind(this));
    };
    const setupClickListenerForLabel = () => {
      const label = this.ownerDocument.querySelector(`[for="${this.id}"]`);
      if (label) {
        setupMouseDownAnimationListenerForElement(label);
        const labelClick = (e) => {
          e.stopImmediatePropagation();
          this[internal.ids].inner.click();
        };
        label.addEventListener('click', labelClick);
        this.listenerCleanup = [...this.listenerCleanup, () => label.removeEventListener('click', labelClick)];
      }
    };
    const setupDocumentMouseUpListener = () => {
      const mouseUpDocListener = () => this.removeAnimationArtifact();
      document.addEventListener(`mouseup`, mouseUpDocListener.bind(this));
      this.listenerCleanup = [...this.listenerCleanup, () => document.removeEventListener('mouseUp', mouseUpDocListener)]
    };

    setupKeyUpAnimationListenerForElement(this);
    setupMouseDownAnimationListenerForElement(this);
    setupClickListenerForLabel();
    setupDocumentMouseUpListener();
  }

  disconnectedCallback() {
    this.listenerCleanup.forEach(cleanup => cleanup());
  }

  enableAnimation() {
    if (this.shouldShowPressAnimation()) {
      this[internal.ids].checkable.classList.add('pressed');
    }
  }

  removeAnimationArtifact() {
    this[internal.ids].checkable.classList.remove('pressed');
  }

  [internal.keydown](event) {
    if (spacebarWasPressed(event)) {
      this.enableAnimation();
    }
  }

  [internal.render](changed) {
    super[internal.render](changed);
    if (changed.name) {
      this.renderName();
    }
    if (changed.value) {
      this.renderValue();
    }
  }

  renderName() {
    if (!this.shadowRoot) return;
    this[internal.ids].inner.name = this.name;
  }

  renderValue() {
    if (!this.shadowRoot) return;
    this[internal.ids].inner.value = this.value;
  }
}

export default CheckableInputBase;